import { createSelector } from 'reselect';
import { DefaultSearchContext } from '../utils/constants';
export var processDataSelector = function (state) { return state.process.processData; };
var selectorDict = {};
export var processListSelector = function (processName, searchId) {
    if (searchId === void 0) { searchId = DefaultSearchContext; }
    var identifier = processName + "_" + searchId;
    if (selectorDict[identifier]) {
        return selectorDict[identifier];
    }
    selectorDict[identifier] = createSelector(processDataSelector, function (processData) {
        var processObj = processData[processName] || {};
        var searchResults = (processObj.searchList || {})[identifier] || [];
        var dict = processObj.dict || {};
        return searchResults.map(function (result) { return dict[result]; }).filter(function (res) { return !!res; });
    });
    console.log('precessListSelector returning', identifier, selectorDict);
    return selectorDict[identifier];
};
export var processInstanceSelector = function (processName, processId) {
    if (selectorDict[processName + '::' + processId]) {
        return selectorDict[processName + '::' + processId];
    }
    selectorDict[processName + '::' + processId] = createSelector(processDataSelector, function (processData) {
        var processDict = (processData[processName] || {}).dict || {};
        var processRefs = (processData[processName] || {}).references || [];
        var hasRef = processRefs.findIndex(function (ref) { return ref.id === processId; });
        return hasRef !== -1 ? processDict[processId] : undefined;
    });
    return selectorDict[processName + '::' + processId];
};
export var processDataCountSelector = function (process, searchId) {
    if (searchId === void 0) { searchId = DefaultSearchContext; }
    return function (state) {
        var identifier = process + "_" + searchId;
        var processData = state.process.processData;
        if (processData[process] && processData[process].count[identifier]) {
            return processData[process].count[identifier];
        }
        return 0;
    };
};
export var processFullSearchIdsList = function (modelAlias, searchId) {
    if (searchId === void 0) { searchId = DefaultSearchContext; }
    return function (state) {
        var _a, _b;
        var identifier = modelAlias + "_" + searchId;
        return (_b = (_a = state.process.processData[modelAlias]) === null || _a === void 0 ? void 0 : _a.fullSearchIds) === null || _b === void 0 ? void 0 : _b[identifier];
    };
};
//# sourceMappingURL=process.js.map